<template>
  <div class="event-results">
    <div class="event-results__header">
      Rezultat zawodnika
    </div>
    <ul>
      <li v-if="workout.total_distance_done">
          <i slot="prepend" v-tooltip="'Zaplanowany dystans'" class="fi flaticon-road-1 "></i>
          {{allWorkoutDistances}}
      </li>
      <li v-if="workout.runner_time">
          <i slot="prepend" v-tooltip="'Tempo/Czas'" class="fi flaticon-minutes "></i>
          {{workout.runner_time}}
      </li>
      <li v-if="workout.runner_pulse">
          <i slot="prepend" v-tooltip="'Tętno'" class="fi flaticon-pulse-line "></i>
          {{workout.runner_pulse}} bpm
      </li>
    </ul>
  </div>
</template>
<script>
import TextField from '@/utils/TextField'
export default {
  components: {TextField},
  props: {
    workout: {
      type: Object,
      required: true
    }
  },
  computed: {
    allWorkoutDistances () {
      let s = ''
      let index = 0
      for (let el of this.workout.elements) {
        let d = el.distance_string
        if (d !== undefined && d !== null) {
          if (index > 0) {
            s += ' / '
          }
          s += d
          index++
        }
      }
      return s
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/DoneWorkoutElements.vue